module.exports = __webpack_public_path__ + "img/esther.a4d0cce9.png";